<script setup lang="ts">

import {onMounted, ref} from "vue";
import {FindOne, UrlQuery, useWebPopup, WebInput} from "lct-lib";
import {useCartStore} from "../cart.store";
import _ from "lodash";

const {show, hide} = useWebPopup();
const orderId = ref<any>(0);
const email = ref("");
const order = ref();
const isDraft = ref(false);

const {addItem} = useCartStore();

onMounted(async () => {
    orderId.value = Number(UrlQuery("id"));
    email.value = <string>UrlQuery("e");
    isDraft.value = !!(UrlQuery("draft") && UrlQuery("draft") === "1");

    if (orderId.value && email.value) {
        await getOrder();
    }
})

const getOrder = async () => {
    try {
        if(!order.value && !email.value) return;
        show();
        const result = await FindOne("orders", {_id: Number(orderId.value), $or: [{email: email.value}, {"customer.email": email.value}]});
        order.value = result;
        hide();
    } catch (e) {
        console.log(e)
    }
}

const addDraftToCart = async () => {
    for (const item of order.value.items) {
        if (item.sale_price === "99.99" || item.sale_price === 99.99) {
            item.sale_price = "69.99"
        }
        if (item.sale_price === "13.99" || item.sale_price === 13.99) {
            item.sale_price = "3.99"
        }
        addItem(item);
    }
    show("You have successfully added it to your cart. <br/> Please proceed to checkout.", ()=>{
        location.href = "/cart";
    })

}

</script>

<template>
<div c2c-0 class="cc h-min:500">
    <div c2c-1 class="w-100%-max:1200">
        <div v-if="!isDraft" c2c-2 class="p-12 cc">
            <div c2c-3 class="w-100%-max:500 bg-0 sd bd">
                <p c2c-4 class="tb bg-0-l:-10 p-12">Search for an order.</p>
                <div c2c-5 class="p-12 m_end">
                    <web-input label="Order Id" v-model="orderId"></web-input>
                    <web-input label="Email" v-model="email"></web-input>
                    <button c2c-6 class="w-100% btl-blue" @click="getOrder">
                        View
                    </button>
                </div>
            </div>
        </div>
        <div c2c-7 class="p-12" v-if="order">

            <div c2c-8 class="rm rw m-b-12">
                <p v-if="!isDraft" c2c-9 class="tb fs-25">
                    Order detail #{{order._id}}
                </p>
                <p v-else c2c-10 class="tb fs-25">
                    View design
                </p>
                <p v-if="order.created_at" v-day="order.created_at"></p>
            </div>

            <table c2c-11 class="bg-0 w-100% bd >>td bd p-12 ^ >>th p-12 bd">
                <thead>
                <tr>
                    <th></th>
                    <th>Information</th>
                    <th>Qty</th>
                    <th>Price</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in order.items">
                    <td c2c-12 class="p-tb-12">
                        <div c2c-13 class="block" v-if="item.item_type === 'tool_design'">
                            <a :href="`/design-tool?o=${order._id}&at=${index}`">
                                <div c2c-14 class="h-max:500" v-html="item.svg"></div>
                            </a>
                        </div>
                        <div v-if="item.item_type === 'order_form'">
                            <a :href="`/design-tool?u=${item.svg_url}`">
                                <img :src="item.img_url" alt="">
                            </a>
                            <div c2c-15 class="cc cm m-t-12" v-if="item._id" >
                                <a c2c-16 class="btl-blue w-150" :href="`/team-banner/${item._id}`">Order Form</a>
                            </div>

                        </div>

                        <p c2c-17 class="i" v-if="item.type === 'triangle' || item.type === 'home-plate'">Note: We print a large sheet with multiple Triangle Pennants and Home Plate Pennants inside. Customers cut them into individual pieces.</p>
                        <div v-if="item.option && item.option.label === 'Mini banner'" >
                            <p c2c-18 class="tb">Mini banner +$15.99</p>
                            <p>
                                Note: We print a large sheet with multiple mini banners inside. You cut them into individual mini banners.
                            </p>
                        </div>

                    </td>
                    <td>
                        {{item.information}}
                    </td>
                    <td c2c-19 class="tc">
                        x {{item.qty}}
                    </td>
                    <td c2c-20 class="tc">
                        <div v-if="!isDraft">
                            ${{item.sale_price}}
                        </div>
                        <div v-else>
                            <p c2c-21 class="cr" v-if="item.sale_price === '99.99' || item.sale_price === 99.99">
                                <span c2c-22 class="lt">${{item.sale_price}}</span>
                                <span c2c-23 class="tb c-red">$69.99</span>
                            </p>
                            <p c2c-24 class="cr" v-if="item.sale_price === '13.99' || item.sale_price === 13.99">
                                <span c2c-25 class="lt">${{item.sale_price}}</span>
                                <span c2c-26 class="tb c-red">$3.99</span>
                            </p>
                        </div>
                    </td>
                </tr>
                <tr v-if="!isDraft">
                    <td colspan="4">
                        <p c2c-27 class="tr tb">
                            Subtotal: ${{order.subtotal}}
                        </p>
                    </td>
                </tr>
                <tr v-if="!isDraft">
                    <td colspan="4">
                        <p c2c-28 class="tr tb">
                            Ship cost: ${{order.ship_cost}}
                        </p>
                    </td>
                </tr>
                <tr v-if="!isDraft">
                    <td colspan="4">
                        <p c2c-29 class="tr tb">
                            Tax: ${{order.tax}}
                        </p>
                    </td>
                </tr>
                <tr v-if="!isDraft">
                    <td colspan="4">
                        <p c2c-30 class="tr tb">
                            Total: ${{order.total}}
                        </p>
                    </td>
                </tr>
                </tbody>
            </table>

            <div c2c-31 class="m-tb-12 rr rm">
                <button c2c-32 class="btl-blue" @click="addDraftToCart">Add to cart</button>
            </div>

            <div c2c-33 class="m-t-12 >2 col-2 ^ <2 col-1
                        ^ >div bd
                        ^ >>ul p-12
                        ^ >div>p bg-0-l:-10 p-12
                        ^ >2 >div:f bd-r-w:0">
                <div c2c-34 class="bg-0">
                    <p c2c-35 class="tb">Bill to</p>
                    <ul>
                        <li v-for="(value,key) in order.bill">
                            <p>
                                <span c2c-36 class="cap tb">{{_.startCase(key)}}</span>:
                                <span>{{value}}</span>
                            </p>
                        </li>
                    </ul>
                </div>

                <div c2c-37 class="bg-0 <2 m-t-12">
                    <p c2c-38 class="tb">Ship to</p>
                    <ul>
                        <li v-for="(value,key) in order.ship">
                            <p>
                                <span c2c-39 class="cap tb">{{_.startCase(key)}}</span>:
                                <span>{{value}}</span>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>


            <div v-if="isDraft" c2c-40 class="m-tb-12 bd p-12 bg-0 fs-14">
                Please note that for pennant types such as TRIANGLE PENNANT or HOME PLATE PENNANT, we do not provide cutting services to shape them into a triangle or home plate. We only offer large-format printing in square or rectangular shapes. Therefore, if you order a pennant, we will offer an extremely low price of just $3.99 per pennant. We will print a large sheet that includes all the pennant shapes within and deliver it to you. Upon receiving it, you will need to cut out the pennants yourself. We apologize for this inconvenience and appreciate your understanding.
            </div>

        </div>
        <div v-else>
            <p c2c-41 class="tb tc">No orders found.</p>
        </div>
    </div>
</div>
</template>

<style scoped>

</style><style lang="scss" scoped>.cc[c2c-0] {
                        display: flex; flex-direction: column; align-items: center;
                 }.h-min\:500[c2c-0] {
                        min-height: 500px;
                 }.w-100\%-max\:1200[c2c-1] {
                        width: 100%;max-width: 1200px;
                 }.p-12[c2c-2] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.cc[c2c-2] {
                        display: flex; flex-direction: column; align-items: center;
                 }.w-100\%-max\:500[c2c-3] {
                        width: 100%;max-width: 500px;
                 }.bg-0[c2c-3] {
                        background-color: hsl(0, 0%, 100%);
                 }.sd[c2c-3] {
                        box-shadow: 0 1px 2px 0 rgba(0,0,0,0.2)
                 }.bd[c2c-3] {
                        border-width: 1px; border-style: solid; border-color: hsla(0, 0%, 72.5%, 0.7)
                 }.tb[c2c-4] {
                        font-weight: bold;
                 }.bg-0-l\:-10[c2c-4] {
                        background-color: hsl(0, 0%, 90%);
                 }.p-12[c2c-4] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.p-12[c2c-5] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.w-100\%[c2c-6] {
                        width: 100%;
                 }.p-12[c2c-7] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.rm[c2c-8] {
                        display: flex; flex-direction: row; align-items: center;
                 }.rw[c2c-8] {
                        display: flex; flex-direction: row; justify-content: space-between;
                 }.m-b-12[c2c-8] {
                        margin-bottom: 12px;
                 }.tb[c2c-9] {
                        font-weight: bold;
                 }.fs-25[c2c-9] {
                        font-size: 25px;
                 }.tb[c2c-10] {
                        font-weight: bold;
                 }.fs-25[c2c-10] {
                        font-size: 25px;
                 }.bg-0[c2c-11] {
                        background-color: hsl(0, 0%, 100%);
                 }.w-100\%[c2c-11] {
                        width: 100%;
                 }.bd[c2c-11] {
                        border-width: 1px; border-style: solid; border-color: hsla(0, 0%, 72.5%, 0.7)
                 }.\>\>td.bd[c2c-11] td {
                        border-width: 1px; border-style: solid; border-color: hsla(0, 0%, 72.5%, 0.7)
                 }.\>\>td.p-12[c2c-11] td {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.\>\>th.p-12[c2c-11] th {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.\>\>th.bd[c2c-11] th {
                        border-width: 1px; border-style: solid; border-color: hsla(0, 0%, 72.5%, 0.7)
                 }.p-tb-12[c2c-12] {
                        padding-top: 12px;padding-bottom: 12px;
                 }.block[c2c-13] {
                        display: block;
                 }.h-max\:500[c2c-14] {
                        max-height: 500px;
                 }.cc[c2c-15] {
                        display: flex; flex-direction: column; align-items: center;
                 }.cm[c2c-15] {
                        display: flex; flex-direction: column; justify-content: center;
                 }.m-t-12[c2c-15] {
                        margin-top: 12px;
                 }.w-150[c2c-16] {
                        width: 150px;
                 }.i[c2c-17] {
                        font-style: italic;
                 }.tb[c2c-18] {
                        font-weight: bold;
                 }.tc[c2c-19] {
                        text-align: center;
                 }.tc[c2c-20] {
                        text-align: center;
                 }.cr[c2c-21] {
                        display: flex; flex-direction: column; align-items: flex-end;
                 }.lt[c2c-22] {
                        text-decoration: line-through;
                 }.tb[c2c-23] {
                        font-weight: bold;
                 }.c-red[c2c-23] {
                        color: hsl(0, 100%, 50%);
                 }.cr[c2c-24] {
                        display: flex; flex-direction: column; align-items: flex-end;
                 }.lt[c2c-25] {
                        text-decoration: line-through;
                 }.tb[c2c-26] {
                        font-weight: bold;
                 }.c-red[c2c-26] {
                        color: hsl(0, 100%, 50%);
                 }.tr[c2c-27] {
                        text-align: right;
                 }.tb[c2c-27] {
                        font-weight: bold;
                 }.tr[c2c-28] {
                        text-align: right;
                 }.tb[c2c-28] {
                        font-weight: bold;
                 }.tr[c2c-29] {
                        text-align: right;
                 }.tb[c2c-29] {
                        font-weight: bold;
                 }.tr[c2c-30] {
                        text-align: right;
                 }.tb[c2c-30] {
                        font-weight: bold;
                 }.m-tb-12[c2c-31] {
                        margin-top: 12px;margin-bottom: 12px;
                 }.rr[c2c-31] {
                        display: flex; flex-direction: row; justify-content: flex-end;
                 }.rm[c2c-31] {
                        display: flex; flex-direction: row; align-items: center;
                 }.m-t-12[c2c-33] {
                        margin-top: 12px;
                 }@media (min-width: 768px) {.\>2.col-2[c2c-33] {
                        
        display: flex;
        flex-flow: row wrap;
    
                > *:nth-child(2n+1) {
                    width: calc(100% / 2);
                }
            
                > *:nth-child(2n+2) {
                    width: calc(100% / 2);
                }
            
                 }}@media (max-width: 768px) {.\<2.col-1[c2c-33] {
                        
        display: flex;
        flex-flow: row wrap;
    
                > *:nth-child(1n+1) {
                    width: calc(100% / 1);
                }
            
                 }}.\>div.bd[c2c-33] > div {
                        border-width: 1px; border-style: solid; border-color: hsla(0, 0%, 72.5%, 0.7)
                 }.\>\>ul.p-12[c2c-33] ul {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.\>div\>p.bg-0-l\:-10[c2c-33] > div > p {
                        background-color: hsl(0, 0%, 90%);
                 }.\>div\>p.p-12[c2c-33] > div > p {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }@media (min-width: 768px) {.\>2.\>div\:f.bd-r-w\:0[c2c-33] > div:first-child {
                        border-right-width: 0;
                 }}.bg-0[c2c-34] {
                        background-color: hsl(0, 0%, 100%);
                 }.tb[c2c-35] {
                        font-weight: bold;
                 }.cap[c2c-36] {
                        text-transform: capitalize;
                 }.tb[c2c-36] {
                        font-weight: bold;
                 }.bg-0[c2c-37] {
                        background-color: hsl(0, 0%, 100%);
                 }@media (max-width: 768px) {.\<2.m-t-12[c2c-37] {
                        margin-top: 12px;
                 }}.tb[c2c-38] {
                        font-weight: bold;
                 }.cap[c2c-39] {
                        text-transform: capitalize;
                 }.tb[c2c-39] {
                        font-weight: bold;
                 }.m-tb-12[c2c-40] {
                        margin-top: 12px;margin-bottom: 12px;
                 }.bd[c2c-40] {
                        border-width: 1px; border-style: solid; border-color: hsla(0, 0%, 72.5%, 0.7)
                 }.p-12[c2c-40] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.bg-0[c2c-40] {
                        background-color: hsl(0, 0%, 100%);
                 }.fs-14[c2c-40] {
                        font-size: 14px;
                 }.tb[c2c-41] {
                        font-weight: bold;
                 }.tc[c2c-41] {
                        text-align: center;
                 }</style>